import Header from "../components/Header";
import BlockTable from "../components/BlockTable";

const Blocks = () => {
  return (
    <div>
      <Header />
      <BlockTable />
    </div>
  );
};

export default Blocks;
